// _requestedDate computation moved to cart.js with periodic maintenance.

const popupHTML = ({ image, icon, title, price, description }) =>
	`${image}<h3>protect your shipment</h3>
<div>
	${icon}
	<h5>${title}</h5>
	<figure>${price}</figure>
</div>
<p>${description}</p>
<div class="buttons">
	<a class="button" href="/cart" id="deny">no thanks</a>
	<button id="accept">add this</button>
</div>`;

const productForm = document.querySelector("form.shopify-product-form");

if (productForm) {
	productForm.addEventListener("submit", async (e) => {
		e.preventDefault();
		let awaitingInput = false;
		const {
			id: { value: id },
			imagethumbnail: { value: image },
		} = e.target;
		const messageInput = e.target.querySelector(
			'textarea[name="properties[message]"]',
		);
		const arrivesInput = e.target.querySelector(`[name="properties['selected date']"]`);
		const deliveryDate = arrivesInput?.value?.trim() || "";
		const messageValue = messageInput?.value?.trim() || "";

		if (messageInput) {
			if (!messageValue) {
				messageInput.setCustomValidity("Please enter a custom message.");
				messageInput.reportValidity();
			} else {
				messageInput.setCustomValidity("");
			}
		}

		if (!deliveryDate || (messageInput && !messageValue)) {
			return;
		}
		try {
			// Collect any pre-selected fillings (e.g., checkboxes with data-filling attribute)
			const fillingInputs = e.target.querySelectorAll(
				'input[type="checkbox"][data-filling]:checked',
			);
			const fillings = Array.from(fillingInputs)
				.map((el) => el.getAttribute("data-filling-label")?.trim() || "")
				.filter((v) => v.length);
			const uniqueFillings = Array.from(new Set(fillings));
			const arrives =
				e.target.querySelector(`[name="properties['selected date']"]`)?.value?.trim() ||
				undefined;
			const requestedDateIso =
				e.target
					.querySelector('[name="properties[_requestedDate]"]')
					?.value?.trim() || undefined;
			// _requestedDate intentionally omitted here; cart.js will compute & maintain it.
			const properties = {
				_id: id,
				message: messageInput?.value ?? undefined,
				_fillings: uniqueFillings.length ? uniqueFillings.join(",") : undefined,
				"selected date": arrives,
				_requestedDate: requestedDateIso,
			};
			const upsellElements = e.target.querySelectorAll(
				'.upsell:not(.popup-upsell) input[type="checkbox"]:checked',
			);
			const hash = await generateCryptoSignature(properties);
			const upsellProducts = Array.from(upsellElements).map((upsell) => ({
				id: upsell.getAttribute("data-variant-id"),
				properties: {
					_linked: hash,
				},
			}));
			const [product] = await addProducts([
				{ id, properties: { _hash: hash, ...properties } },
				...upsellProducts,
			]);
			const popupUpsellElement = e.target.querySelector(
				".upsell.popup-upsell input",
			);
			if (!popupUpsellElement) return;
			awaitingInput = true;
			const popup = NavBar.globalSetNav("popup");
			const iconHTML = `<img src="${popupUpsellElement.getAttribute(
				"data-image",
			)}" />`;
			const imageHTML = `<img src="${image}" />`;
			popup.innerHTML = popupHTML({
				image: imageHTML,
				icon: iconHTML,
				title: popupUpsellElement.getAttribute("data-title"),
				price: popupUpsellElement.getAttribute("data-price"),
				description: popupUpsellElement.getAttribute("data-description"),
			});
			const acceptButton = popup.querySelector("#accept");
			const denyButton = popup.querySelector("#deny");
			acceptButton.addEventListener("click", async () => {
				try {
					acceptButton.setAttribute("disabled", "disabled");
					denyButton.setAttribute("disabled", "disabled");
					acceptButton.innerHTML = "Adding...";
					await addProduct(popupUpsellElement.getAttribute("data-variant-id"), {
						_linked: hash,
					});
					popup.innerHTML = "";
					NavBar.globalSetNav("popup", false);
				} catch (error) {
					console.error("Error adding upsell product to cart:", error);
				} finally {
					acceptButton.removeAttribute("disabled");
					denyButton.removeAttribute("disabled");
					acceptButton.innerHTML = "Add this";
					window.location = "/cart";
				}
			});
		} catch (error) {
			console.error("Error displaying popup:", error);
		} finally {
			if (awaitingInput) return;
			window.location = "/cart";
		}
	});
}

const initProductFormRequirements = () => {
	const form = document.querySelector("form.shopify-product-form");
	if (!form) return;

	const addToCartButton = form.querySelector('button[name="add"]');
	const arrivesInput = form.querySelector(`[name="properties['selected date']"]`);
	const messageInput = form.querySelector(
		'textarea[name="properties[message]"]',
	);
	if (!addToCartButton) return;

	const updateState = () => {
		const hasDate = Boolean(arrivesInput?.value?.trim());
		const hasMessage = messageInput ? Boolean(messageInput.value.trim()) : true;
		addToCartButton.disabled = !(hasDate && hasMessage);
	};

	arrivesInput?.addEventListener("change", updateState);
	messageInput?.addEventListener("input", () => {
		messageInput.setCustomValidity("");
		updateState();
	});

	updateState();
};

const initRequestedDatePickers = () => {
	const pickers = document.querySelectorAll("[data-date-picker]");
	if (!pickers.length) return;
	const dateUtils = window.RequestedDateUtils;
	if (!dateUtils) return;

	const parseHolidayList = (value) =>
		(value || "")
			.split(",")
			.map((item) => item.trim())
			.filter(Boolean)
			.map((item) => dateUtils.parseDateKey(item))
			.filter(Boolean);

	const formatISODate = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	};

	const formatISOWithOffset = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const offsetMinutes = -date.getTimezoneOffset();
		const sign = offsetMinutes >= 0 ? "+" : "-";
		const absMinutes = Math.abs(offsetMinutes);
		const offsetHours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
		const offsetMins = String(absMinutes % 60).padStart(2, "0");
		return `${year}-${month}-${day}T00:00:00${sign}${offsetHours}:${offsetMins}`;
	};

	const formatLabel = (date) => {
		const formatted = new Intl.DateTimeFormat("en-US", {
			weekday: "long",
			month: "long",
			day: "numeric",
			year: "numeric",
		}).format(date);
		return formatted;
	};

	const stripTime = (date) =>
		new Date(date.getFullYear(), date.getMonth(), date.getDate());

	pickers.forEach((picker) => {
		const hiddenInput = picker.querySelector("[data-date-value]");
		const isoInput = picker.querySelector("[data-requested-date-iso]");
		const title = picker.querySelector(".date-picker__title");
		const grid = picker.querySelector(".date-picker__grid");
		const navButtons = picker.querySelectorAll(".date-picker__nav");
		if (!hiddenInput || !isoInput || !title || !grid) return;

		const fulfillmentHolidays = parseHolidayList(
			picker.getAttribute("data-fulfillment-holidays"),
		);
		const fedexHolidays = parseHolidayList(
			picker.getAttribute("data-fedex-holidays"),
		);
		const getConstraints = () =>
			dateUtils.computeDeliveryConstraints({
				now: new Date(),
				fulfillmentHolidays,
				fedexHolidays,
				leadMinutes: 30,
			});
		let constraints = getConstraints();
		let minDateLocal = dateUtils.dateKeyToLocalDate(
			constraints.minSelectableDateKey,
		);
		let minVisibleMonth = new Date(
			minDateLocal.getFullYear(),
			minDateLocal.getMonth(),
			1,
		);
		let currentMonth = new Date(
			minVisibleMonth.getFullYear(),
			minVisibleMonth.getMonth(),
			1,
		);
		let selected = null;

		const toMonthKey = (date) => date.getFullYear() * 12 + date.getMonth();
		const setVisibleMonth = (date) => {
			currentMonth = new Date(date.getFullYear(), date.getMonth(), 1);
		};
		const isBeforeMinVisibleMonth = () =>
			toMonthKey(currentMonth) < toMonthKey(minVisibleMonth);

		const logMinDateComputation = (ruleSet) => {
			if (picker.dataset.minDateLogShown) return;
			console.groupCollapsed(
				"[Date Picker] Minimum selectable date derivation",
			);
			console.log("Current local date/time:", ruleSet.now.toString());
			console.log("Current ISO date/time:", ruleSet.now.toISOString());
			console.log("Timezone used:", ruleSet.timezone);
			console.log(
				"Current store date key used for rules:",
				ruleSet.currentChicagoDateKey,
			);
			console.log(
				"Normalized store-time date floor:",
				ruleSet.normalizedDateKey,
			);
			console.log(
				"Step 1: Add 1 fulfillment business day from",
				ruleSet.normalizedDateKey,
			);
			ruleSet.fulfillmentTrace.forEach((step, index) => {
				console.log(
					`  ${index + 1}. ${step.dateKey} -> ${step.reason} (${step.counted ? "counted" : "skipped"}; running count ${step.addedSoFar}/1)`,
				);
			});
			const fulfillmentReady =
				ruleSet.fulfillmentTrace[ruleSet.fulfillmentTrace.length - 1]?.dateKey;
			console.log("Fulfillment ready date:", fulfillmentReady);
			console.log("Step 2: Add 2 FedEx business days from", fulfillmentReady);
			ruleSet.fedexTrace.forEach((step, index) => {
				console.log(
					`  ${index + 1}. ${step.dateKey} -> ${step.reason} (${step.counted ? "counted" : "skipped"}; running count ${step.addedSoFar}/2)`,
				);
			});
			console.log(
				"Saturday/Monday exception window:",
				ruleSet.specialAllowedDateKeys.length
					? ruleSet.specialAllowedDateKeys.join(", ")
					: "not active",
			);
			console.log("Minimum selectable date:", ruleSet.minSelectableDateKey);
			console.groupEnd();
			picker.dataset.minDateLogShown = "true";
		};

		const applySelection = (date) => {
			selected = date;
			setVisibleMonth(date);
			const label = formatLabel(date);
			hiddenInput.value = label;
			isoInput.value = formatISOWithOffset(date);
			hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
		};

		const render = () => {
			constraints = getConstraints();
			logMinDateComputation(constraints);
			minDateLocal = dateUtils.dateKeyToLocalDate(
				constraints.minSelectableDateKey,
			);
			minVisibleMonth = new Date(
				minDateLocal.getFullYear(),
				minDateLocal.getMonth(),
				1,
			);
			const today = stripTime(new Date());

			if (
				selected &&
				!dateUtils.isDateSelectable(formatISODate(selected), constraints)
			) {
				selected = null;
				hiddenInput.value = "";
				isoInput.value = "";
				hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
			}

			if (isBeforeMinVisibleMonth()) {
				currentMonth = new Date(
					minVisibleMonth.getFullYear(),
					minVisibleMonth.getMonth(),
					1,
				);
			}

			const monthName = new Intl.DateTimeFormat("en-US", {
				month: "long",
				year: "numeric",
			}).format(currentMonth);
			title.textContent = monthName;

			navButtons.forEach((button) => {
				const direction = button.getAttribute("data-direction");
				if (direction !== "prev") {
					button.disabled = false;
					return;
				}
				const atMinMonth =
					toMonthKey(currentMonth) === toMonthKey(minVisibleMonth);
				button.disabled = atMinMonth;
			});

			grid.innerHTML = "";

			const firstDay = new Date(
				currentMonth.getFullYear(),
				currentMonth.getMonth(),
				1,
			);
			const startDay = firstDay.getDay();
			const daysInMonth = new Date(
				currentMonth.getFullYear(),
				currentMonth.getMonth() + 1,
				0,
			).getDate();

			for (let i = 0; i < startDay; i += 1) {
				const filler = document.createElement("span");
				filler.className = "date-picker__cell is-empty";
				grid.appendChild(filler);
			}

			for (let day = 1; day <= daysInMonth; day += 1) {
				const date = new Date(
					currentMonth.getFullYear(),
					currentMonth.getMonth(),
					day,
				);
				const button = document.createElement("button");
				button.type = "button";
				button.className = "date-picker__cell";
				button.textContent = String(day);
				button.setAttribute("role", "gridcell");
				button.dataset.date = formatISODate(date);

				if (!dateUtils.isDateSelectable(button.dataset.date, constraints)) {
					button.classList.add("is-disabled");
					button.disabled = true;
				}
				if (selected && formatISODate(date) === formatISODate(selected)) {
					button.classList.add("is-selected");
				}
				if (formatISODate(date) === formatISODate(today)) {
					button.classList.add("is-today");
				}

				button.addEventListener("click", () => {
					applySelection(date);
					render();
				});

				grid.appendChild(button);
			}

			const filledCells = startDay + daysInMonth;
			const totalCells = 42;
			const nextMonthDays = Math.max(totalCells - filledCells, 0);
			for (let day = 1; day <= nextMonthDays; day += 1) {
				const date = new Date(
					currentMonth.getFullYear(),
					currentMonth.getMonth() + 1,
					day,
				);
				const button = document.createElement("button");
				button.type = "button";
				button.className = "date-picker__cell is-outside";
				button.textContent = String(day);
				button.setAttribute("role", "gridcell");
				button.dataset.date = formatISODate(date);

				if (!dateUtils.isDateSelectable(button.dataset.date, constraints)) {
					button.classList.add("is-disabled");
					button.disabled = true;
				}
				if (selected && formatISODate(date) === formatISODate(selected)) {
					button.classList.add("is-selected");
				}
				if (formatISODate(date) === formatISODate(today)) {
					button.classList.add("is-today");
				}

				button.addEventListener("click", () => {
					applySelection(date);
					render();
				});

				grid.appendChild(button);
			}
		};

		navButtons.forEach((button) => {
			button.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopPropagation();
				const direction = button.getAttribute("data-direction");
				if (button.disabled) return;
				if (direction === "prev") {
					const prevMonth = new Date(
						currentMonth.getFullYear(),
						currentMonth.getMonth() - 1,
						1,
					);
					if (toMonthKey(prevMonth) < toMonthKey(minVisibleMonth)) {
						return;
					}
				}
				const delta = direction === "prev" ? -1 : 1;
				currentMonth = new Date(
					currentMonth.getFullYear(),
					currentMonth.getMonth() + delta,
					1,
				);
				render();
			});
		});

		render();
		setInterval(
			() => {
				render();
			},
			5 * 60 * 1000,
		);
	});
};

initRequestedDatePickers();
initProductFormRequirements();
